import { useState, useMemo, useCallback } from "react";

import { validateCampaignName } from "../utils/campaign-name-validation";

interface IUseCampaignNameReturn {
    campaignName: string;
    setCampaignName: (name: string) => void;
    isCampaignNameValid: boolean;
    resetCampaignName: () => void;
}

export const useCampaignName = (): IUseCampaignNameReturn => {
    const [campaignName, setCampaignNameState] = useState("");

    const isCampaignNameValid = useMemo(() => {
        return validateCampaignName(campaignName, true).isValid;
    }, [campaignName]);

    const setCampaignName = useCallback((name: string) => {
        setCampaignNameState(name);
    }, []);

    const resetCampaignName = useCallback(() => {
        setCampaignNameState("");
    }, []);

    return {
        campaignName,
        setCampaignName,
        isCampaignNameValid,
        resetCampaignName,
    };
};
